import { createContext } from 'react'

type AIAgentContextValue = {
  isPinUnlocked: boolean
  isUnlocking: boolean
  unlockPin: (pinCode: string) => Promise<boolean>
}

export const AIAgentContext = createContext<AIAgentContextValue | null>(null)
